type GpsBadgeProps = {
  geoReady: boolean;
  geoError: string | null;
};

export const GpsBadge = ({ geoReady, geoError }: GpsBadgeProps) => {
  const ok = geoReady && !geoError;

  return (
    <span
      style={{
        background: ok ? "#f0fdf4" : "#fefce8",
        borderColor: ok ? "#bbf7d0" : "#fde68a",
        color: ok ? "#15803d" : "#92400e",
      }}
    >
      {ok ? "GPS sẵn sàng" : geoError ? "GPS lỗi" : "Đang định vị..."}
    </span>
  );
};
